import { render, staticRenderFns } from "./subscription-table-input.vue?vue&type=template&id=00980801&scoped=true&"
import script from "./subscription-table-input.ts?vue&type=script&lang=ts&"
export * from "./subscription-table-input.ts?vue&type=script&lang=ts&"
import style0 from "./subscription-table-input.scss?vue&type=style&index=0&id=00980801&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00980801",
  null
  
)

export default component.exports